export const HFS_WEBSITE = 'https://www.hfsfin.com/';
